import { Component,Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IAlertDialogData } from '../interfaces';

@Component({
  selector: 'app-alert-NV',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css'],
})
export class AlertComponent {

  constructor(  @Inject(MAT_DIALOG_DATA) public data: IAlertDialogData) {

  }
}
